module.exports = __webpack_public_path__ + "static/media/A3.4f46a826.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A3.png
// module id = 869
// module chunks = 0